/** Same-tab signal fired after a rating window is saved (the socket covers other tabs and users). */
export const RATING_WINDOW_EVENT = "ratingWindowUpdated";

// setTimeout overflows above 2^31-1 ms (~24.8 days).
const MAX_TIMER_MS = 2 ** 31 - 1;
const BOUNDARY_PADDING_MS = 1000;

interface RatingWindowStatus {
  window_start?: string | null;
  window_end?: string | null;
}

/**
 * Milliseconds until the next moment the window opens or closes, or null when no
 * boundary lies ahead. Padded by a second so the server sees the new state.
 */
export function nextRatingBoundaryDelay(status: RatingWindowStatus | null | undefined, now = Date.now()): number | null {
  const boundaries = [status?.window_start, status?.window_end]
    .map((value) => (value ? new Date(value).getTime() : NaN))
    .filter((time) => Number.isFinite(time) && time > now);
  if (boundaries.length === 0) return null;
  return Math.min(Math.min(...boundaries) - now + BOUNDARY_PADDING_MS, MAX_TIMER_MS);
}

export function notifyRatingWindowChanged(chapterId: number): void {
  window.dispatchEvent(new CustomEvent(RATING_WINDOW_EVENT, { detail: { chapter_id: chapterId } }));
}
